import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Elm Street</title>
        <meta name="description" content="Elm Street" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/" />
        <meta property="og:title" content=" - Elm Street" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <div
        style={{
          backgroundImage: "url('horizonbg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "350px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    <span style={{ color: mainTheme.palette.secondary.main }}>We</span> Create
                    <br />
                    Success
                  </Typography>
                  <p>
                    What happens when thinkers, innovators and over-achievers come together with one shared mindset?
                  </p>
                  <Typography variant="h5" component="h2" style={{ color: mainTheme.palette.secondary.main }}>
                    WE CALL IT ELM STREET.
                  </Typography>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container maxWidth="lg">
        <div style={{ marginTop: "48px", marginBottom: "48px" }}>
          <Grid container spacing={8}>
            <Grid item md={12}>
              <Typography variant="h1" component="h1">
                H1
              </Typography>
              <Typography variant="h2" component="h2">
                H2
              </Typography>
              <Typography variant="h3" component="h3">
                H3
              </Typography>
              <Typography variant="h4" component="h4">
                H4
              </Typography>
              <Typography variant="h5" component="h5">
                H5
              </Typography>
              <p>body text</p>
              <div>
                <Button variant="text">Text</Button>
                <Button variant="contained">Contained</Button>
                <Button variant="outlined">Outlined</Button>
              </div>
              <div>
                <Button variant="text" color="secondary">
                  Text
                </Button>
                <Button variant="contained" color="secondary">
                  Contained
                </Button>
                <Button variant="outlined" color="secondary">
                  Outlined
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
